module.exports = __webpack_public_path__ + "static/numbers-3-3-134bac0aa3f861a52b5a917bf00c0631.png";